import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { breakpoints, fontFamily, functions, colors } from '../../ui/variables';

export const RequestPasswordStyle = styled.main`
  background-color: ${colors.gray};
  box-sizing: border-box;
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone + 52}px 52px 52px;
  width: 100%;

   .form-content {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          margin: 0 auto;
          max-width: 468px;
        }
        .buttons-row {
          display: flex;
          gap: 12px;
        }
    }

  .error-message {
    color: ${colors.softRed};
    text-align: center;
    margin-top: 10px;
  }

  .success-message {
      color: ${colors.limeGreen};
      text-align: center;
      margin-top: 10px;
  }

  .request-password {
    &-title {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.softBlue};
      font-size: 30px;
      line-height: 36px;
      margin-bottom: 8px;
      text-align: center;
    }

    &-description {
      color: ${colors.darkGrayishBlue};
      margin-bottom: 24px;
      font-family: SourceSansPro;
      font-weight: normal;
      font-style: normal;
      color: #424242;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }
  }

  .reset-password {
    &-title {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.softBlue};
      font-size: 30px;
      line-height: 36px;
      margin-bottom: 8px;
      text-align: center;
    }
`;
